export default __webpack_public_path__ + "3f8230a4a51d4ceb5ca05dbaae11564c.png";